export const SIZE = {
	XL: 'extraLarge',
	LARGE: 'large',
	MEDIUM: 'medium',
	SMALL: 'small',
	XS: 'extraSmall',
	XSS: 'extraSmallSmall',
};

export const COLOR = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	ERROR: 'error',
	WARNING: 'warning',
	INFO: 'info',
	SUCCESS: 'success',
	DEFAULT: 'default',
	SETTING: 'setting',
};

export const VARIANT = {
	FILLED: 'filled',
	OUTLINED: 'outlined',
	STANDARD: 'standard',
};

export const TYPE = {
	SEARCH: 'search',
};
